import { render, staticRenderFns } from "./customHeader.vue?vue&type=template&id=f6283b6e&scoped=true"
import script from "./customHeader.vue?vue&type=script&lang=js"
export * from "./customHeader.vue?vue&type=script&lang=js"
import style0 from "./customHeader.vue?vue&type=style&index=0&id=f6283b6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6283b6e",
  null
  
)

export default component.exports